import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Carousel from "react-bootstrap/Carousel";

function About() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <div style={{ marginTop: '10rem', width: '100%', height: '10px' }} className="about-scroll"></div>

      <div className="container about py-5">
        <div className="row align-items-center">
          <div className="col-md-6 text-center" data-aos="fade-right">
            <img
              alt="about"
              src="./img/img1.png"
              className="img-fluid rounded"
              style={{ maxHeight: "400px" }}
            />
          </div>

          <div className="col-md-6" data-aos="fade-left">
            <h2 className="main-title about-h2 mb-3">ABOUT US</h2>
            <p className="main-p" style={{ fontSize: "1.1rem" }}>
              <strong>RAS BSNS INC.</strong> is a service-first company committed to redefining everyday convenience.
              We specialize in sourcing and distributing essential products across three key domains: <strong>fragrances</strong>,
              <strong> kitchen staples</strong>, and <strong>clothing</strong>. Our focus is on building reliable, efficient delivery networks while
              maintaining a strong commitment to quality and trust.
            </p>
            <p className="main-p" style={{ fontSize: "1.1rem" }}>
              Whether it's stocking up your kitchen, upgrading your wardrobe, or refreshing your environment with premium fragrances,
              we’re here to make it seamless and dependable—backed by a mission to bring comfort to your home.
            </p>
          </div>
        </div>

      </div>
    </>
  );
}

export default About;
